export default "__VITE_ASSET__eab003cc__"